import { Link } from "react-router-dom";

import nosServices from "../assets/nos-services.jpg";

const services = [
  {
    icon: "bi-tools",
    title: "Maintenance et support informatique",
    text: "Maintenance des systèmes et des logiciels, et assistance à distance ou sur site pour résoudre les problèmes informatiques.",
  },
  {
    icon: "bi-lightbulb",
    title: "Consultation en TI",
    text: "Conseils d'experts sur la stratégie informatique, l'optimisation des processus d'affaires et la transformation numérique.",
  },
  {
    icon: "bi-shield-check",
    title: "Sécurité informatique",
    text: "Audits de sécurité, mise en place de mesures de protection et surveillance des réseaux pour prévenir les menaces.",
  },
  {
    icon: "bi-hdd-network",
    title: "Gestion de réseaux et d'infrastructures",
    text: "Conception, mise en place et gestion de réseaux informatiques, administration de serveurs, stockage et cloud computing.",
  },

  {
    icon: "bi-file-earmark-lock2",
    title: "Conformité à la Loi 25",
    text: "Accompagnement pour répondre aux exigences de la Loi 25 : gestion des accès et protection des renseignements personnels de vos patients.",
  },

  {
    icon: "bi-layout-text-window-reverse",
    title: "Support niveau 1 des logiciels dentaires",
    text: "Dépannage et support technique pour vos logiciels de gestion et d'imagerie dentaire : Dentitek, Dentonovo, Progident, Romexis, DTX Studio, Adstra et bien d'autres.",
  },
  {
    icon: "bi-microsoft",
    title: "Solutions cloud Microsoft",
    text: "Migration et gestion de Microsoft 365 et Azure, pour un environnement cloud fiable et bien protégé.",
  },
  {
    icon: "bi-database-fill-gear",
    title: "Récupération de données et sauvegarde",
    text: "Sauvegarde des données et récupération en cas de perte, pour garantir la continuité de vos opérations.",
  },
  {
    icon: "bi-diagram-3",
    title: "Intégration de systèmes",
    text: "Combinaison de divers systèmes informatiques et logiciels pour créer une solution cohérente et intégrée.",
  },
  {
    icon: "bi-envelope-paper",
    title: "Messagerie et collaboration",
    text: "Mise en place et gestion de solutions de messagerie, de vidéoconférence et de collaboration en ligne.",
  },
];

export default function Services() {
  return (
    <>
      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Nos services</span>
              <h1 className="fw-900 mt-3 display-5">
                Une seule équipe pour toute votre informatique
              </h1>
              <p className="lead text-secondary mt-3">
                Fini les multiples fournisseurs et les responsabilités
                partagées. Grâce à notre approche de guichet unique, notre
                équipe prend en charge l'ensemble de vos besoins technologiques,
                du support quotidien aux projets d'envergure, afin que vous
                puissiez vous concentrer sur vos patients, vos clients et votre
                croissance.
              </p>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="section-img">
                <img
                  src={nosServices}
                  alt="Baie de brassage réseau entretenue par CPUc"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <div className="row g-4">
            {services.map((s, i) => (
              <div
                className="col-md-6 col-lg-3"
                key={s.title}
                data-aos="fade-up"
                data-aos-delay={(i % 4) * 100}
              >
                <div className="service-card p-4">
                  <div className="service-icon mb-3">
                    <i className={`bi ${s.icon}`}></i>
                  </div>
                  <h3 className="h6 fw-bold">{s.title}</h3>
                  <p className="text-secondary small mb-0">{s.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Carte vedette téléphonie IP */}
          <Link
            to="/telephonie-ip"
            className="featured-card d-block p-4 p-md-5 mt-4 text-decoration-none"
            data-aos="zoom-in"
          >
            <div className="row align-items-center gy-3">
              <div className="col-auto">
                <div
                  className="rounded-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "64px",
                    height: "64px",
                    background: "rgba(229,53,43,0.18)",
                  }}
                >
                  <i className="bi bi-telephone-fill fs-3 text-brand"></i>
                </div>
              </div>
              <div className="col">
                <h3 className="fw-900 mb-1" style={{ color: "#fff" }}>
                  Téléphonie IP
                </h3>
                <p className="mb-0" style={{ color: "#C7C7CC" }}>
                  Remplacez votre système téléphonique traditionnel par une
                  solution infonuagique flexible, mobile et économique.
                </p>
              </div>
              <div className="col-auto d-none d-md-block">
                <span className="fw-bold" style={{ color: "#fff" }}>
                  Découvrir{" "}
                  <i className="bi bi-arrow-right ms-1 text-brand"></i>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}
